import { Button, Drawer, Image, Modal, Space, Table, Typography } from "antd";
import axios from "axios";
import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { NotificationInfo, UserInfo } from "../../../../context";
import { useReactToPrint } from "react-to-print";
import {
  PrinterOutlined,
  DollarOutlined,
  FileImageOutlined,
} from "@ant-design/icons";
import PaymentOrder from "./PaymentOrder";
import moment from "moment";
import AddDiscount from "./AddDiscount";

const MerchantOrderDetails = ({
  open,
  close,
  selectedData,
  getMerchantOrderSaveList,
}) => {
  const { userData } = useContext(UserInfo);
  const scroll = {};
  const [orderDetailsList, setOrderDetailsList] = useState({
    data: [],
    ready: false,
  });
  const tableLayout = "";
  const componentRef = useRef();
  const [paddingPrint, setPaddingPrint] = useState(0);
  const [displayDetailsPrint, setDisplayDetailsPrint] = useState(false);
  const [openPaymentDiag, setOpenPaymentDiag] = useState(false);
  const [total, setTotal] = useState(0);
  const [discountAmount, setDiscountAmount] = useState(0);
  const [openDiscountDiag, setOpenDiscountDiag] = useState(false);
  const [visible, setVisible] = useState(false);
  const scaleStep = 0.5;
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [ePaymentDialog, setEPaymentDialog] = useState(false);
  const { rerunNotif } = useContext(NotificationInfo);

  const tableProps = {
    bordered: false,
    size: "medium",
    // expandable,
    showHeader: true,
    scroll,
    tableLayout,
  };

  const columns = [
    {
      title: "Product",
      dataIndex: ["deliverysaverawproduct", "product"],
    },
    {
      title: "Expiry Date",
      // dataIndex: ["deliverysaverawproduct", "description"],
      dataIndex: "expiry_date",
    },
    {
      title: "Unit",
      dataIndex: ["deliverysaverawproduct", "rawproductsuserunit", "unit"],
      align: "right",
    },
    {
      title: "Qty * MSRP",
      // dataIndex: "quantity",
      align: "right",
      render: (text, record) => (
        <>
          {text.quantity} * {text.deliverysaverawproduct.msrp}
        </>
      ),
    },
    {
      title: "Amount",
      // dataIndex: ["deliverysaverawproduct", "msrp"],
      align: "right",
      render: (text, record) => (
        <>
          {parseFloat(
            parseFloat(text.quantity) *
              parseFloat(text.deliverysaverawproduct.msrp)
          ).toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}
        </>
      ),
    },
  ];

  const tableColumns = columns.map((item) => ({
    ...item,
    ellipsis: false,
  }));

  //   console.log("selectedData", selectedData);

  const calculateTotal = (data) => {
    var total = 0;
    for (let i = 0; i < data.length; i++) {
      total +=
        parseFloat(data[i].deliverysaverawproduct.msrp) *
        parseFloat(data[i].quantity);
    }
    return total;
  };

  const getMerchantInvoiceDetails = useCallback(() => {
    var params = {
      user_id: userData.data.id,
      invoice_number: selectedData !== null ? selectedData.invoice_number : "",
    };
    axios
      .get("user/commissary/spec-invoice-info", {
        params,
      })
      .then((response) => {
        const data = response.data;
        setOrderDetailsList({ data, ready: true });
        setDiscountAmount(
          parseFloat(
            data[0].discount_amount !== null ? data[0].discount_amount : 0
          )
        );
        setTotal(calculateTotal(data));
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.id, selectedData]);

  useEffect(() => {
    getMerchantInvoiceDetails();
  }, [getMerchantInvoiceDetails]);

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,

    onBeforeGetContent: () => {
      return new Promise((resolve) => {
        setPaddingPrint(10);
        setDisplayDetailsPrint(true);
        resolve();
      });
    },
    onAfterPrint: () => {
      setPaddingPrint(0);
      setDisplayDetailsPrint(false);
    },
  });

  const handleEPaymentOk = () => {
    setConfirmLoading(true);
    setTimeout(() => {
      setEPaymentDialog(false);
      setConfirmLoading(false);
      handleConfirmEPaymentAsPaid();
    }, 2000);
  };

  // console.log("SELECTEDATA", selectedData);

  const handleConfirmEPaymentAsPaid = () => {
    const formdata = new FormData();
    formdata.append("user_id", userData.data.id);
    formdata.append("invoice_number", selectedData.invoice_number);
    formdata.append("po_number_id", selectedData.po_number_id);

    axios
      .post("user/commissary/confirm-epayment", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "success") {
          rerunNotif("success", "Confirm e-payment as paid successfully.");
          setTimeout(() => {
            close();
            getMerchantOrderSaveList();
          }, 1000);
        }
      })
      .catch((error) => {
        console.log("ERROR: ", error);
        // setLoadings(false);
      });
  };

  return (
    <Drawer
      title="Merchant Order Details"
      width={window.innerWidth > 500 ? 600 : "100vw"}
      onClose={close}
      open={open}
      bodyStyle={{
        paddingBottom: 80,
      }}
      extra={
        <Space>
          <Button
            type="primary"
            onClick={() => {
              setOpenDiscountDiag(true);
            }}
            disabled={
              parseInt(selectedData.payment_status) !== 0 ? true : false
            }
          >
            Add Discount
          </Button>
        </Space>
      }
    >
      {selectedData !== null && (
        <div
          style={{ overflowX: "auto", padding: paddingPrint }}
          ref={componentRef}
        >
          {displayDetailsPrint && (
            <Typography.Title level={4} style={{ marginBottom: 15 }}>
              {selectedData.invoice_number} - Merchant Order
            </Typography.Title>
          )}

          <Typography level={4}>
            Created P.O:{" "}
            <b>
              {orderDetailsList.data.length > 0 &&
                orderDetailsList.data[0].po_number}
            </b>
          </Typography>
          <Typography level={4}>
            Created Ref.#:{" "}
            <b>
              {orderDetailsList.data.length > 0 &&
                orderDetailsList.data[0].po_number_id}
            </b>
          </Typography>
          <Typography level={4}>
            Invoice #:{" "}
            <b>
              {orderDetailsList.data.length > 0 &&
                orderDetailsList.data[0].invoice_number}
            </b>
          </Typography>
          <Typography level={4}>
            Invoice Date:{" "}
            <b>
              {orderDetailsList.data.length > 0 &&
                moment(
                  new Date(orderDetailsList.data[0].invoice_date),
                  "YYYY-MM-DD"
                ).format("MMMM DD, YYYY")}
            </b>
          </Typography>
          {orderDetailsList.data.length > 0 && (
            <Typography level={4}>
              Payment Status:{" "}
              <b
                style={{
                  color:
                    parseInt(orderDetailsList.data[0].payment_status) === 1
                      ? "green"
                      : parseInt(orderDetailsList.data[0].payment_status) === 2
                      ? "orange"
                      : "red",
                }}
              >
                {parseInt(orderDetailsList.data[0].payment_status) === 1
                  ? "Paid"
                  : parseInt(orderDetailsList.data[0].payment_status) === 2
                  ? "Pending"
                  : "Unpaid"}
              </b>
            </Typography>
          )}

          {orderDetailsList.data.length > 0 &&
            orderDetailsList.data[0].ref_no !== null && (
              <div
                style={{
                  // border: "1px solid red",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <div style={{ flexGrow: 1 }}>
                  <Typography level={4}>
                    Reference #: <b>{orderDetailsList.data[0].ref_no}</b>
                  </Typography>
                </div>
                {/* IMAGE HERE */}
                <Button
                  type="primary"
                  icon={<FileImageOutlined />}
                  onClick={() => setVisible(true)}
                  style={{
                    display:
                      orderDetailsList.ready &&
                      orderDetailsList.data[0].payment_method === "ecash"
                        ? "block"
                        : "none",
                  }}
                  size="small"
                >
                  View Attachment
                </Button>
              </div>
            )}

          {/* IMAGE VIEW */}
          {orderDetailsList.data.length > 0 &&
            orderDetailsList.data[0].payment_method === "ecash" && (
              <div>
                <Image
                  width={200}
                  style={{
                    display: "none",
                  }}
                  src=""
                  preview={{
                    visible,
                    scaleStep,
                    src: `${process.env.REACT_APP_API_IMAGE}payment/${orderDetailsList.data[0].payment_attachment}`,
                    onVisibleChange: (value) => {
                      setVisible(value);
                    },
                  }}
                />
              </div>
            )}

          <Table
            {...tableProps}
            // pagination={{
            //   position: ["bottomRight"],
            // }}
            pagination={false}
            columns={tableColumns}
            dataSource={
              orderDetailsList.data.length > 0 ? orderDetailsList.data : []
            }
            scroll={scroll}
            rowKey={(record) => record.raw_id}
            footer={() => (
              <div style={{ display: "flex" }}>
                <div style={{ flexGrow: 1 }} />
                <div>
                  <Typography align="right">
                    Total:{" "}
                    <b>
                      <i>
                        {total.toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </i>
                    </b>
                  </Typography>
                  {orderDetailsList.data.length > 0 &&
                  orderDetailsList.data[0].discount_category !== null ? (
                    <>
                      <Typography align="right">
                        Discount:{" "}
                        {orderDetailsList.data[0].discount_category ===
                        "percentage"
                          ? `${orderDetailsList.data[0].discount_percentage}%`
                          : ""}{" "}
                        <b>
                          <i>
                            {discountAmount.toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </i>
                        </b>
                      </Typography>

                      <Typography align="right">
                        Grand Total:{" "}
                        <b>
                          <i>
                            {parseFloat(total - discountAmount).toLocaleString(
                              undefined,
                              {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              }
                            )}
                          </i>
                        </b>
                      </Typography>
                    </>
                  ) : null}
                </div>
              </div>
            )}
          />
        </div>
      )}

      <Button
        type="dashed"
        // loading={loadings}
        // htmlType="submit"
        style={{ width: "100%", borderRadius: "20px", marginTop: 10 }}
        onClick={() => {
          if (parseInt(selectedData.payment_status) === 2) {
            setEPaymentDialog(true);
          } else {
            setOpenPaymentDiag(true);
          }
        }}
        disabled={parseInt(selectedData.payment_status) === 1 ? true : false}
        icon={<DollarOutlined />}
      >
        {/* {loadings ? "Loading" : "Confirm all"} */}
        {parseInt(selectedData.payment_status) === 2
          ? "Confirm Payment"
          : "Payment"}
      </Button>

      <Button
        type="primary"
        onClick={handlePrint}
        icon={<PrinterOutlined />}
        style={{ width: "100%", borderRadius: "20px", marginTop: 10 }}
      >
        Print
      </Button>

      {openPaymentDiag && (
        <PaymentOrder
          closeOriginalTab={() => close()}
          open={openPaymentDiag}
          close={() => setOpenPaymentDiag(false)}
          selectedData={selectedData}
          total={total - discountAmount}
          getMerchantOrderSaveList={() => getMerchantOrderSaveList()}
          getMerchantInvoiceDetails={() => getMerchantInvoiceDetails()}
        />
      )}

      {openDiscountDiag && (
        <AddDiscount
          open={openDiscountDiag}
          close={() => setOpenDiscountDiag(false)}
          total={total}
          po_number_id={
            orderDetailsList.data.length > 0 &&
            orderDetailsList.data[0].po_number_id
          }
          invoice_number={
            orderDetailsList.data.length > 0 &&
            orderDetailsList.data[0].invoice_number
          }
          discount_category={
            orderDetailsList.data.length > 0 &&
            orderDetailsList.data[0].discount_category !== null
              ? orderDetailsList.data[0].discount_category
              : ""
          }
          discount_percentage={
            orderDetailsList.data.length > 0 &&
            orderDetailsList.data[0].discount_percentage !== null
              ? orderDetailsList.data[0].discount_percentage
              : ""
          }
          discount_amount={
            orderDetailsList.data.length > 0 &&
            orderDetailsList.data[0].discount_amount !== null
              ? orderDetailsList.data[0].discount_amount
              : ""
          }
          getMerchantInvoiceDetails={() => getMerchantInvoiceDetails()}
        />
      )}

      <Modal
        title="Are you sure to confirm this payment as paid?"
        open={ePaymentDialog}
        onOk={handleEPaymentOk}
        confirmLoading={confirmLoading}
        onCancel={() => setEPaymentDialog(false)}
        centered
      />
    </Drawer>
  );
};

export default MerchantOrderDetails;
